import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function AuthSuccess() {
  const { refreshSession } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    (async () => {
      const authenticated = await refreshSession();
      if (!active) return;
      navigate(authenticated ? '/real' : '/real/login', { replace: true });
    })();
    return () => {
      active = false;
    };
  }, [navigate, refreshSession]);

  return (
    <div className="loading-page">
      <div className="loading-mark">K</div>
      <p>Preparing your dashboard...</p>
    </div>
  );
}
